// Components
const ModalSocialAddMembers = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "modal-social-add-members"*/ "@/app/views/main-view/social-club/components/modals/modal-social-add-members/modal-social-add-members.vue"
	)
const ModalSocialMemberRequest = () =>
	import(
		/* webpackPrefetch: true, webpackChunkName: "modal-social-member-request"*/ "@/app/views/main-view/social-club/components/modals/modal-social-member-request/modal-social-member-request.vue"
	)

// Mixins
import { tableMixins } from "@/app/mixins/utils/table-mixins.js"
import { toastMessageMixins } from "@/app/mixins/utils/toast-message-mixins"
import { dateMixins } from "@/app/mixins/utils/date-mixins.js"
import { inputTextMixins } from "@/app/mixins/utils/input-text-mixins"
import { userMixins } from "@/app/mixins/modules/user-mixins.js"

// Services
import ClubService from "@/app/services/main/club/club-service.js"

// Constants
import { STATUS_CODES, USER_CLUB_ACCESS, USER_CLUB_STATUS } from "@/app/constants/status-constants"

export default {
	name: "SocialClubAdminManagement",
	components: {
		ModalSocialAddMembers,
		ModalSocialMemberRequest,
	},
	mixins: [tableMixins, toastMessageMixins, dateMixins, inputTextMixins, userMixins],
	data() {
		return {
			isAPILoading: true,
			// table
			theads: this.checkMemberAccess(),
			desc: true,
			// filter
			accessList: [
				{ name: "Member", value: USER_CLUB_ACCESS.MEMBER },
				{ name: "Admin", value: USER_CLUB_ACCESS.ADMIN },
				{ name: "Pending", value: USER_CLUB_ACCESS.PENDING },
			],
		}
	},
	created() {
		this.getTableContent()
	},
	computed: {
		getActiveGroup() {
			return this.$store.getters.getActiveGroup
		},
		isUserRoleClubCreator() {
			return this.$store.getters.getClubCreator
		},
		groupAdminRequests() {
			return this.$store.getters.getGroupAdminRequests
		},
	},
	methods: {
		checkMemberAccess() {
			let theads = []
			if (this.$store.getters.getClubCreator) {
				theads = [
					{
						name: "Name",
						searchLabel: "f_name",
						sortLabel: "name",
						isDesc: false,
						hasSearch: true,
						style: null,
					},
					{
						name: "Admin Status",
						searchLabel: "f_access",
						isDesc: false,
						hasAccessSearch: true,
						style: "max-width: 120px",
					},
					{ name: "Remove", style: "max-width: 60px" },
				]
			} else {
				theads = [
					{
						name: "Name",
						searchLabel: "f_name",
						sortLabel: "reporter",
						isDesc: false,
						hasSearch: true,
						style: null,
					},
					{ name: "Remove", style: "max-width: 60px" },
				]
			}

			return theads
		},
		getTableContent(page = this.page, limit = this.limit, sortBy = this.sortBy, desc = this.desc, fromFilter = false) {
			page = fromFilter ? 1 : this.page
			this.getMemberList({ page, limit, sortBy, desc })
		},
		getMemberList(queryParams) {
			this.isAPILoading = true

			queryParams.f_groupId = this.getActiveGroup.id
			queryParams.f_status = "ACTIVE"
			queryParams.f_user = this.userDetails.customerId

			if (this.columnsFilter) {
				if (this.columnsFilter.f_name) {
					queryParams["f_name"] = this.columnsFilter.f_name
				}
				if (this.columnsFilter.f_access) {
					queryParams["f_access"] = this.columnsFilter.f_access
				}
			}
			
			// Call API service to get the table content
			ClubService.getAllGroupMembers(queryParams)
				.then((res) => {
					if (res.status === STATUS_CODES.SUCCESS) {
						this.tableContent = {
							tableData: res.data.data,
							paginationData: res.data.pagination,
						}
					} else {
						const { ERROR_GET_REPORTED_LIST } = this.toastMessages.report()
						this.showAPIErrorToast(ERROR_GET_REPORTED_LIST, res)
					}

					this.isAPILoading = false
				})
				.catch(() => {
					this.showGenericErrorToast()
					this.isAPILoading = false
				})
		},
		showCreateGroupModal() {
			// Open create group modal under social club admin component
			this.$emit("showCreateGroupModal")
		},
		showAddMembersModal() {
			this.$refs.addMembersModal.openModal()
		},
		showMemberRequestModal() {
			this.$refs.memberRequestModal.openModal()
		},
		approveDisapprovedAdminRequest(approve, customerId) {
			const title = approve ? "Approve Admin Request" : "Disapprove Admin Request"
			const action = approve ? "approve" : "disapprove"
			const requestBody = {
				customerId,
				access: approve ? USER_CLUB_ACCESS.ADMIN : USER_CLUB_ACCESS.MEMBER,
			}
			this.$swal({
				title,
				text: `Are you sure you want to ${action} request?`,
				confirmButtonText: "Confirm",
				showCancelButton: true,
				cancelButtonText: "Cancel",
				reverseButtons: true,
			}).then((result) => {
				if (result.value) {
					this.updateMemberAccess(false, requestBody)
				}
			})
		},
		setAdminStatus(event, id) {
			const title = event.target.checked ? "Appoint Admin" : "Remove admin"
			const action = event.target.checked ? "appoint" : "remove"
			const requestBody = {
				customerId: id,
				access: event.target.checked ? USER_CLUB_ACCESS.ADMIN : USER_CLUB_ACCESS.MEMBER,
			}
			// show modal confirmation
			this.$swal({
				title,
				text: `Are you sure you want to ${action} this customer as an admin?`,
				confirmButtonText: "Confirm",
				showCancelButton: true,
				cancelButtonText: "Cancel",
				reverseButtons: true,
			}).then((result) => {
				if (result.value) {
					this.updateMemberAccess(event, requestBody)
				} else {
					event.target.checked = !event.target.checked
				}
			})
		},
		updateMemberAccess(event, requestBody) {
			ClubService.updateGroupMemberAccess(this.getActiveGroup.id, requestBody)
				.then(async (res) => {
					const {
						SUCCESS_UPDATE_GROUP_MEMBER_ACCESS_TITLE,
						SUCCESS_UPDATE_GROUP_MEMBER_ACCESS_TEXT,
						ERROR_UPDATE_GROUP_MEMBER_ACCESS,
					} = this.toastMessages.club(this.getActiveGroup)

					if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
						this.showCustomSuccessToast(
							SUCCESS_UPDATE_GROUP_MEMBER_ACCESS_TITLE,
							SUCCESS_UPDATE_GROUP_MEMBER_ACCESS_TEXT
						)
						
						// refresh table
						this.getTableContent(false, this.page,this.sortBy, this.limit, this.desc, false)
						await this.$store.dispatch("setGroupAdminRequest")
					} else {
						this.showAPIErrorToast(ERROR_UPDATE_GROUP_MEMBER_ACCESS, res)
						
						// reset toggle
						if (event) {
							event.target.checked = !event.target.checked
						}
					}

					// refresh table
					this.isAPILoading = false
				})
				.catch(() => {
					this.showGenericErrorToast()

					// reset toggle
					if (event) {
						event.target.checked = !event.target.checked
					}
				})
		},
		removeMemberFromGroup({ id, firstName, lastName }) {
			this.$swal({
				title: `Remove Member`,
				text: `Are you sure you want to remove ${firstName}  ${lastName} from the group?`,
				confirmButtonText: "Confirm",
				showCancelButton: true,
				cancelButtonText: "Cancel",
				reverseButtons: true,
			}).then((result) => {
				if (result.value) {
					const requestBody = {
						customerIds: [id],
						status: USER_CLUB_STATUS.INACTIVE,
					}

					ClubService.updateGroupMemberStatus(this.getActiveGroup.id, requestBody)
						.then(async (res) => {
							const {
								SUCCESS_REMOVE_GROUP_MEMBER_TITLE,
								SUCCESS_REMOVE_GROUP_MEMBER_TEXT,
								ERROR_UPDATE_GROUP_MEMBER_ACCESS,
							} = this.toastMessages.club(this.getActiveGroup)

							if (res.status === STATUS_CODES.SUCCESS_NO_CONTENT) {
								this.showCustomSuccessToast(
									SUCCESS_REMOVE_GROUP_MEMBER_TITLE,
									SUCCESS_REMOVE_GROUP_MEMBER_TEXT
								)

								await this.$store.dispatch("setGroupAdminRequest")
							} else {
								this.showAPIErrorToast(ERROR_UPDATE_GROUP_MEMBER_ACCESS, res)
							}
							
							// refresh table
							this.getTableContent(this.page, this.limit, this.sortBy, this.desc, false)
						})
						.catch(() => {
							// refresh table
							this.getTableContent(this.page, this.limit, this.sortBy, this.desc, false)
							this.showGenericErrorToast()
						})
				}
			})
		},
		updateAdminManagement() {
			this.getTableContent(this.page, this.limit, this.sortBy, this.desc, false)
		},
		checkPendingMemberRequest() {
			const findMemberRequest = this.groupAdminRequests.memberRequests.find(
				(memberRequest) => memberRequest.groupId === this.getActiveGroup.id
			)

			return findMemberRequest && findMemberRequest.memberRequestCount > 0 ? true : false
		},
	},
}
